module.exports = __webpack_public_path__ + "static/media/watch1_after.09d62555.jpg";